import ProcedureImportService from '@Client/runner.services/procedure.import.service';
import { CreationHubServiceType } from '@Client/runner.services/creation-hub.service';
import SetupDeleteApiService from '@Client/runner.setup/runner.setup.delete/runner.setup.delete.api.services';
import { getInjector } from '@Shared.Angular/flowingly.helper/serviceInjector';
import { SharedServiceTypeMap } from '@Shared.Angular/flowingly.hooks/useService';
import { FlowApiServiceType } from '@Client/runner.services/flow.api.service';
import { MaintenanceServiceType } from '@Client/runner.services/maintenance.service';
import { IUsSpinnerService } from '@Shared.Angular/@types/angular.spinner';

/**
 * Hook to get angularJs service via injector
 * @typedef T - type of the service
 * @param name
 * @returns T - the angularJs service
 * @deprecated Use `getService` instead.
 */
export const useService = <T>(name: RunnerServiceName): T =>
  getInjector().get(name) as T;

type ServiceTypeMap = SharedServiceTypeMap & {
  authService: AuthService;
  runnerStartFlowsFormatter: RunnerStartFlowsFormatter;
  runnerCategoryFilterService: RunnerCategoryFilterService;
  flowListManager: FlowListManager;
  flowTodoService: FlowTodoService;
  flowImInService: FlowImInService;
  flowModelImportService: FlowModelImportService;
  lodashService: Lodash;
  runnerCategoryNavigationService: RunnerCategoryNavigationService;
  proceduresService: ProceduresService;
  maintenanceService: MaintenanceServiceType;
  libraryService: LibraryService;
  usSpinnerService: IUsSpinnerService;
  runnerPublicMapApiService: RunnerPublicMapApiService;
  smartSearchService: SmartSearchService;
  roleApiService: RoleApiService;
  setupDeleteApiService: SetupDeleteApiService;
  tagService: TagService;
  businessApiService: BusinessApiService;
  procedureImportService: ProcedureImportService;
  governanceApiService: GovernanceApiService;
  flowApiService: FlowApiServiceType;
  runnerFlowsFormatter: RunnerFlowsFormatterService;
  dateService: DateService;
  sideMenuService: SideMenuService;
  videoRecordingService: VideoRecordingService;
  creationHubService: CreationHubServiceType;
};

export const getService = <K extends RunnerServiceName>(
  name: K
): ServiceTypeMap[K] => getInjector().get(name) as ServiceTypeMap[K];
